import React from 'react'
import type { GlobalSearchAction } from './GlobalSearchState'
import type GlobalSearchState from './GlobalSearchState'
import noop from 'lib/function/noop'

// TODO: Update global search state types to support undefined as an empty object probably is viable default (but the types don't think so)
export const GlobalSearchStateContext = React.createContext<GlobalSearchState>({} as any)
export const GlobalSearchDispatchContext = React.createContext<React.Dispatch<GlobalSearchAction>>(noop)
